import { customEvent, generateLeadEvent } from "../../modules/tracking/AnalyticsEvents";
import { getFromStorage } from "../../used-vue/api/Storage";
require('../../modules/polyfills/remove');

export default class {
    constructor(options) {
        this.liveChatOpen = false;
        this.currentStep = '';
        this.brand = '';
        if (typeof brand !== 'undefined' && brand !== '') {
            this.brand = brand;
        }
        this.name = '';
        // setTimeout handler
        this.replaceCardContentTimeout = false;
        this.quickAnimation = false;
        this.providerScriptLoaded = false;

        // Bodyscroll lock is needed for iOS modal as it scrolls the background instead of the modal
        this.bodyScrollLock = false;

        // If the body element has data-activity-type, use it to set the customer SDE type
        if (document.body.dataset.activityType) {
            let activityData = document.body.dataset.activityType;
            this.setCustomerType(((activityData) ? activityData : 'Unknown'));
        }

        this.redesign = false;
        if (typeof options != 'undefined') {
            if (typeof options.redesign != 'undefined' && options.redesign == true) {
                this.redesign = true;
            }
        }

        this.initialiseChatProvider();

        window.addEventListener('cookies:accepted:functional', () => {
            this.initialiseChatProvider();
        });

        window.addEventListener("hashchange", (event) => {
            if (typeof liveChatDisabled != 'undefined' && liveChatDisabled === true) {
                console.warn('Live Chat is disabled');
                return;
            }
            const hash = location.hash.substring(1);
            if (hash == 'live-chat') {
                this.quickAnimation = true;
                // this.openLiveChat();
            }
        });

        const hash = location.hash.substring(1);
        if (hash == 'live-chat') {
            this.quickAnimation = true;
            // this.openLiveChat();
        }
    }

    hasAcceptedFunctionalCookies() {
        return getFromStorage('cookies_accepted') == 1 && getFromStorage('cookies_functional') == 1;
    }

    async initialiseChatProvider() {
        return this.loadConfiguredProvider();
    }

    async loadConfiguredProvider() {
        if (!this.hasAcceptedFunctionalCookies()) {
            return null;
        }

        if (this.providerScriptLoaded) {
            return 'agentlauncher';
        }

        this.loadAgentLauncherScript();

        this.providerScriptLoaded = true;

        return 'agentlauncher';
    }

    loadScriptOnce(src, id, configure = null, onload = null) {
        const existingScript = document.getElementById(id);
        if (existingScript) {
            return existingScript;
        }

        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.async = true;

        if (typeof configure === 'function') {
            configure(script);
        }

        if (typeof onload === 'function') {
            script.onload = onload;
        }

        document.head.appendChild(script);
        return script;
    }

    loadAgentLauncherScript() {
        // this.loadScriptOnce(
        //     'https://app.agent.autoconverse.ai/dist/js/launcher.min.js',
        //     'agent-launcher-script',
        //     null,
        //     () => {
        //         if (window.AgentLauncher && typeof window.AgentLauncher.init === 'function') {
        //             window.AgentLauncher.init();
        //         }
        //     }
        // );
    }

    async getActiveAgentLauncher() {
        return new Promise(resolve => {
            if (window.AgentLauncher) {
                resolve(window.AgentLauncher);
                return;
            }

            const waitingForAgentLauncherInterval = window.setInterval(() => {
                if (window.AgentLauncher) {
                    resolve(window.AgentLauncher);
                    clearInterval(waitingForAgentLauncherInterval);
                }
            }, 250);
        });
    }

    /**
     * Preserve the public API used by page entry points.
     *
     * @param {Object} vehicleData
     */
    setVehicleData(vehicleData) {
        this.vehicleData = vehicleData;
    }

    /**
     * Preserve the public API used by page entry points.
     *
     * @param {Object} customerData
     */
    setCustomerData(customerData) {
        this.customerData = customerData;
    }

    /**
     * Preserve the public API used by page entry points.
     *
     * @param {String} type
     */
    setCustomerType(type) {
        this.customerType = type;
    }

    /**
     * Preserve the public API used by page entry points.
     *
     * @param {String} postcode
     */
    setCustomerPostcode(postcode) {
        this.customerPostcode = postcode;
    }

    /**
     * Used to trigger live chat depending on the page type
     */
    async openLiveChat(locationId = false) {
        if (typeof liveChatDisabled != 'undefined' && liveChatDisabled === true) {
            console.warn('Live Chat is disabled');
            return;
        }

        if (!this.hasAcceptedFunctionalCookies()) {
            return;
        }

        if (this.liveChatOpen) {
            return;
        }

        await this.loadConfiguredProvider();
        this.liveChatOpen = true;
    }

    async openAgentLauncher() {
        await this.loadConfiguredProvider();
        // const agentLauncher = await this.getActiveAgentLauncher();

        // if (agentLauncher && typeof agentLauncher.open === 'function') {
        //     agentLauncher.open();
        // }
    }

    /**
     * Show the live chat drop in card.
     * If the card is already showing in the same state, this will do nothing.
     * If there is already an active live chat conversation, this will do nothing
     *
     * @param {int} locationId (optional) The location.id of the dealer to use
     */
    async initLiveChat(locationId = false) {
        return this.openLiveChat(locationId);
    }


    /**
     * Start the chat window
     */
    async startChat() {
        await this.openAgentLauncher();

        customEvent('Live Chat', 'Start Chat', 'AgentLauncher widget opened');
        generateLeadEvent('live_chat');

        // this.removeCard();
        return;
    }
}